import { Link } from "react-router-dom";
import logo from "../../../assets/logo.svg";
import L from "../../../constants/baysportLabels";
import AuthSteps from "./AuthSteps";
import a from "./auth.module.css";

export default function PlatformAuthShell({
  backTo = "/",
  backLabel = "На главную",
  title,
  subtitle,
  stepCurrent,
  stepTotal,
  stepLabels,
  children,
  footer,
}) {
  const hasSteps =
    stepCurrent != null &&
    stepTotal != null &&
    stepTotal > 1 &&
    Array.isArray(stepLabels) &&
    stepLabels.length > 0;

  return (
    <div className={`${a.page} ${a.pagePlatform}`}>
      <div className={a.platformWrap}>
        <header className={a.platformHeader}>
          <Link to={backTo} className={a.platformBack}>
            ← {backLabel}
          </Link>
          <Link to="/" className={a.platformBrand}>
            <img src={logo} alt="" className={a.platformLogo} width={36} height={36} />
            <span>{L.productName}</span>
          </Link>
        </header>

        <main className={a.platformCard}>
          <div className={a.platformCardHead}>
            <h1 className={a.platformTitle}>{title}</h1>
            {subtitle ? <p className={a.platformSubtitle}>{subtitle}</p> : null}
            {hasSteps ? (
              <div className={a.platformSteps}>
                <AuthSteps
                  current={stepCurrent}
                  total={stepTotal}
                  labels={stepLabels}
                />
              </div>
            ) : null}
          </div>

          <div className={a.platformBody}>{children}</div>

          {footer ? <div className={a.platformFoot}>{footer}</div> : null}
        </main>

        <p className={a.platformLegal}>
          © {new Date().getFullYear()} {L.productName}
        </p>
      </div>
    </div>
  );
}
